<template>
  <BaseDialog
    v-model="showDialog"
    title="Filter"
    dialogIcon="mdi-filter-variant"
    scrollable
    :btnActionName="btnActionName"
    :btnCloseName="btnCloseName"
    :btnCloseColor="btnCloseColor"
    :persistent="persistent"
    :no-click-animation="noClickAnimation"
    @action="$emit('action')"
  >
    <template v-slot:title>
      <v-card-title class="headline primary--text mb-3 safeAreaTop">
        <v-avatar class="mr-2" size="36" color="primary">
          <v-icon dark>{{ dialogIcon }}</v-icon>
        </v-avatar>
        {{ title }}
      </v-card-title>
    </template>

    <template v-slot>
      <slot></slot>
    </template>
    <template v-slot:btn>
      <slot name="btn"></slot>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "BaseFilterDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    dialogIcon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
    btnCloseName: {
      type: String,
      default: "Lukk",
    },
    btnCloseColor: {
      type: String,
    },
    btnActionName: {
      type: String,
      default: null,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    noClickAnimation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filteroptions: null,
    };
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
